import { cn } from '@simplywallst/ui-core/next';
import { Tooltip } from '../Tooltip';
import { PositiveNegativeValue } from '../PositiveNegativeValue';
import { formatterPercentage } from '@/utilities/format';

import type { PortfolioDetailedReturns } from '../../hooks/usePortfolioDetailedReturns';

type Props = Pick<
  PortfolioDetailedReturns['detailedReturns'],
  | 'unrealizedGainsPercent'
  | 'realizedGainsPercent'
  | 'dividendsPercent'
  | 'currencyGainsPercent'
  | 'totalGainsPercent'
> & {
  notTransactionalPortfolio: boolean;
};

export const TotalPercent = ({
  unrealizedGainsPercent,
  realizedGainsPercent,
  dividendsPercent,
  currencyGainsPercent,
  totalGainsPercent,
  notTransactionalPortfolio,
}: Props) => {
  const cell = cn(
    'border-b border-l-0 border-r border-t-2 border-solid border-soft p-x2 text-right text-xs font-strong'
  );
  return (
    <tr
      aria-label="Total Percentage"
      className="[&_td:nth-child(10)]:bg-brand-01-softer [&_td:nth-child(n+6):nth-child(-n+9)]:bg-brand-01-subtle"
    >
      <td className={cell} />
      <td className={cell} />
      <td className={cell} />
      <td className={cell} />
      <td className={cell} />
      <td className={cell}>
        <PositiveNegativeValue value={unrealizedGainsPercent}>
          {formatterPercentage(unrealizedGainsPercent)}
        </PositiveNegativeValue>
      </td>
      {notTransactionalPortfolio ? (
        <>
          <td className={cell}>
            <Tooltip
              label="No data"
              tip="This metric is only available for transaction portfolios. Create a transaction portfolio to see your true returns."
            />
          </td>
          <td className={cell}>
            <Tooltip
              label="No data"
              tip="This metric is only available for transaction portfolios. Create a transaction portfolio to see your true returns."
            />
          </td>
          <td className={cell}>
            <Tooltip
              label="No data"
              tip="This metric is only available for transaction portfolios. Create a transaction portfolio to see your true returns."
            />
          </td>
        </>
      ) : (
        <>
          <td className={cell}>
            <PositiveNegativeValue value={realizedGainsPercent}>
              {formatterPercentage(realizedGainsPercent)}
            </PositiveNegativeValue>
          </td>
          <td className={cell}>
            <PositiveNegativeValue value={dividendsPercent}>
              {formatterPercentage(dividendsPercent)}
            </PositiveNegativeValue>
          </td>
          <td className={cell}>
            <PositiveNegativeValue value={currencyGainsPercent}>
              {formatterPercentage(currencyGainsPercent)}
            </PositiveNegativeValue>
          </td>
        </>
      )}
      <td className={cell}>
        <PositiveNegativeValue value={totalGainsPercent}>
          {formatterPercentage(totalGainsPercent)}
        </PositiveNegativeValue>
      </td>
    </tr>
  );
};
